import { Component } from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import sellerFaq from 'features/components/base/faq/sellerFaq';
import buyerfaq from 'features/components/base/faq/buyerfaq';
import BuyerFAQArticleDetail from 'features/components/base/faq/BuyerFAQArticleDetail';
import SellerFAQArticleDetail from 'features/components/base/faq/SellerFAQArticleDetail';
import { SUPPORT_WIDGET_APP_URL, SUPPORT_WIDGET_SRC } from 'shared/settings/config';

const SUPPORT_WIDGET_SCRIPT_ID = 'ctbids-support-widget';
const SUPPORT_WIDGET_CONTAINER_ID = 'ct-bids-widget-container';
const SUPPORT_WIDGET_ROUTES = {
    buyer: '/help-center/buyer',
    seller: '/help-center/seller'
};

export class helpCenterRouter extends Component {

    getSupportWidgetSystemType = (props = this.props) => {
        const pathname = props.location?.pathname;

        if (pathname.startsWith(SUPPORT_WIDGET_ROUTES.buyer)) {
            return 'buyer';
        }

        if (pathname.startsWith(SUPPORT_WIDGET_ROUTES.seller)) {
            return 'seller';
        }

        return '';
    }

    isSupportWidgetRoute = (props = this.props) => Boolean(this.getSupportWidgetSystemType(props));

    removeSupportWidget = () => {
        try {
            window.CTBIDS_SUPPORT_WIDGET?.destroy?.();
        } catch (error) {
            // Widget cleanup should never block route changes.
        }

        document.getElementById(SUPPORT_WIDGET_SCRIPT_ID)?.remove();
        document.getElementById(SUPPORT_WIDGET_CONTAINER_ID)?.remove();

        document
            .querySelectorAll(`iframe[src*="${SUPPORT_WIDGET_APP_URL}"]`)
            .forEach(element => element.remove());
    }

    loadSupportWidget = () => {
        const systemType = this.getSupportWidgetSystemType();

        if (!systemType || document.getElementById(SUPPORT_WIDGET_SCRIPT_ID)) {
            return;
        }

        const script = document.createElement('script');
        script.id = SUPPORT_WIDGET_SCRIPT_ID;
        script.src = SUPPORT_WIDGET_SRC;
        script.async = true;
        script.setAttribute('data-app-url', SUPPORT_WIDGET_APP_URL);
        script.setAttribute('data-system-type', systemType);

        document.body.appendChild(script);
    }

    componentDidMount() {
        this.loadSupportWidget();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.location?.pathname === this.props.location?.pathname) {
            return;
        }

        if (this.isSupportWidgetRoute()) {
            this.removeSupportWidget();
            this.loadSupportWidget();
        } else if (this.isSupportWidgetRoute(prevProps)) {
            this.removeSupportWidget();
        }
    }

    componentWillUnmount() {
        this.removeSupportWidget();
    }

    render() {
        return (
            <Switch>
                <Route exact path={`/help-center/seller/folder/:folderid`} component={sellerFaq} />
                <Route exact path={`/help-center/seller/article/:pageid`} component={SellerFAQArticleDetail} />
                <Route exact path={`/help-center/seller`} component={sellerFaq} />
                <Route exact path={`/help-center/buyer/folder/:folderid`} component={buyerfaq} />
                <Route exact path={`/help-center/buyer/article/:pageid`} component={BuyerFAQArticleDetail} />
                <Route exact path={`/help-center/buyer`} component={buyerfaq} />
                <Redirect to={`/help-center/buyer`} />
            </Switch>
        );
    }
}

export default connect(state => state)(helpCenterRouter);
